import React, { FC } from 'react';
import { Box, Typography } from '@material-ui/core';
import MessageIcon from '@material-ui/icons/Message';
import useStyles from './styles';

const CompaignEmpty: FC = () => {
  const classes = useStyles();

  return (
    <Box className={classes.wrapper}>
      <MessageIcon fontSize="large" />
      <Typography className={classes.title}>Liste des campagnes</Typography>
      <Typography className={classes.subtitle}>
        Il n'y a aucune campagne pour l'instant.
      </Typography>
    </Box>
  );
};

export default CompaignEmpty;
